import React, { useEffect, useState } from 'react'
import ReactCalendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import {
  avatar10,
  avatar6,
  avatar7,
  avatar8,
  avatar9,
  userProfile,
} from '../../assets/images';
import Breadcrumb from '../../components/common/Breadcrumb';

export default function Event() {

  const [addEventModal, setAddEventModal] = useState(false)
  const openAddEventModal = () => {
    setAddEventModal(!addEventModal)
  }
  useEffect(() => {
    document.body.classList[addEventModal ? "add" : "remove"]("overflow-hidden")
  }, [addEventModal])

  return (
    <>
      <Breadcrumb title="Events" path="Events" />
      <div className='grid lg:grid-cols-12 md:gap-30 gap-15'>
        <div className='lg:col-span-8 app-calendar bg-bg-dark shadow-light rounded-lg md:p-20 p-15'>
          <ReactCalendar />
        </div>
        <div className='lg:col-span-4'>
          <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 md:mb-30 mb-15'>
            <button onClick={openAddEventModal} className="btn btn-primary w-full">
              Add New Event
            </button>
          </div>
          <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15'>
            <div className='mb-15 flex items-center justify-center'>
              <img src={userProfile} alt='user' width="140" height="140" className='w-[140px] h-[140px] rounded-full object-cover' />
            </div>
            <p className='text-[24px]/[28px] font-medium text-center mb-5'>
              Alizee Thomas
            </p>
            <p className='text-center mb-[25px]'>Washington, d.c.</p>
            <div className='h-[5px] rounded-full bg-border mb-[25px] overflow-hidden'>
              <div className='w-[89%] bg-blue h-full'></div>
            </div>
            <div className='grid grid-cols-3 gap-10 justify-items-center text-center mb-15'>
              <div>
                <p className='mb-2 font-medium text-[16px]/[20px]'>17</p>
                <span>Completed</span>
              </div>
              <div>
                <p className='mb-2 font-medium text-[16px]/[20px]'>34</p>
                <span>ToDo</span>
              </div>
              <div>
                <p className='mb-2 font-medium text-[16px]/[20px]'>78</p>
                <span>All Tasks</span>
              </div>
            </div>
            <hr className='border-border' />
            <div className='my-15 flex flex-wrap gap-10'>
              <span className='text-black-100 text-[10.5px]/[12px] inline-block py-1 px-2 rounded uppercase border border-current'>Marketing</span>
              <span className='text-info text-[10.5px]/[12px] inline-block py-1 px-2 rounded uppercase border border-current'>DESIGN TASK</span>
              <span className='text-success text-[10.5px]/[12px] inline-block py-1 px-2 rounded uppercase border border-current'>DEVELOPMENT</span>
              <span className='text-blue text-[10.5px]/[12px] inline-block py-1 px-2 rounded uppercase border border-current'>FINANCE</span>
              <span className='text-yellow text-[10.5px]/[12px] inline-block py-1 px-2 rounded uppercase border border-current'>MEETING</span>
              <span className='text-danger text-[10.5px]/[12px] inline-block py-1 px-2 rounded uppercase border border-current'>CONFERENCE</span>
            </div>
            <hr className='border-border' />
            <div className="my-20">
              <p className='text-text-secondary text-[16px]/[20px] font-medium mb-2'>Team</p>
              <ul className="flex items-center">
                <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar10} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {addEventModal &&
        <>
          <div className={`fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]`}>
            <div className='py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light'>
              <h5 className="text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Add Event
              </h5>
              <div className='my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar'>
                <div className='grid grid-cols-1 gap-20'>
                  <div className='form-group flex'>
                    <input type='date' id='birthDate' name='birthDate' placeholder='Birthdate' className='grow' />
                  </div>
                  <div className='form-group'>
                    <input type='text' id='eventTitle' name='eventTitle' placeholder='Event Title' />
                  </div>
                  <div className='form-group flex'>
                    <textarea rows={4} placeholder='Event Description...' />
                  </div>
                </div>
              </div>
              <div className='md:px-10 px-[7px] flex gap-10 justify-end py-10'>
                <button onClick={openAddEventModal} className='btn btn-outline-secondary'>
                  Cancel
                </button>
                <button className='btn btn-primary'>
                  Add
                </button>
              </div>
            </div>
          </div>
          <div onClick={openAddEventModal} className='fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]'></div>
        </>
      }
    </>
  )
}
